<template>
  <img src="../assets/thaicom_xwf_logo.png" width="60" alt=" ">
</template>
<script>
export default {
  name: "VaIconApp",
};
</script>
